import React, { createContext, useContext } from 'react'

const config = {
	use_case_name: process.env.REACT_APP_USE_CASE || 'Project'
}

const ConfigContext = createContext(config)

export const ConfigProvider = ({ children }) => {
	return (
		<ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
	)
}

export const useConfig = () => {
	return useContext(ConfigContext)
}
